import { JSX } from 'react'

import { IconProps } from '../../icon'

const Premium: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M10.4598 29.6384C9.8109 25.4208 9.16205 21.2033 8.5132 16.9857C8.3693 16.0508 9.43309 15.4131 10.1898 15.9807C12.2113 17.4969 14.2328 19.0129 16.2543 20.5291C16.9199 21.0283 17.8682 20.8658 18.3296 20.1736L23.3785 12.6002C23.912 11.7999 25.0879 11.7999 25.6214 12.6002L30.6703 20.1736C31.1317 20.8658 32.08 21.0282 32.7456 20.5291C34.7671 19.0129 36.7886 17.4969 38.8101 15.9807C39.5668 15.4131 40.6306 16.0508 40.4868 16.9857C39.838 21.2033 39.1891 25.4208 38.5403 29.6384H10.4598Z'
      fill='#FFB743'
    />
    <path
      d='M37.0761 36.6584H11.9237C11.1152 36.6584 10.4597 36.003 10.4597 35.1945V31.9785H38.5403V35.1945C38.5401 36.003 37.8847 36.6584 37.0761 36.6584Z'
      fill='#FFB743'
    />
  </svg>
)

export default Premium
